import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';
import TableFooter from '@mui/material/TableFooter';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import Typography from '@mui/material/Typography';
import Loader from 'components/Shared/Loader';

const styles = {
    tableRow: {
        height: 80
    }
}

const ReclamationsTableFooter = ({ classes, isLoading, hasReclamations }) => (
    <TableFooter>
        <TableRow className={classes.tableRow}>
            <TableCell colSpan={15}>
                {!hasReclamations && <Typography variant="body2" align="center">Aucun dossier après-vente, veuillez élargir les critères de recherche.</Typography>}
                {isLoading && <Loader />}
            </TableCell>
        </TableRow>
    </TableFooter>
);

ReclamationsTableFooter.propTypes = {
    classes: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    hasReclamations: PropTypes.bool.isRequired
};

export default withStyles(styles)(ReclamationsTableFooter);
